(function ($) {
  function minicart(obj) {
    var self = this;
    var close = $('.close-action');
    var itemCountTotal = $('.itemcounttotal');
    var renderHtml = $('#cart-notification-product');
    var minicart = obj;

    this.init = function () {
      $.getJSON('/cart.js', function (data) {
        var items = data.items;
        window.document.dispatchEvent(
          new CustomEvent('oc:view_cart', {
            detail: {
              type: 'minicart',
              value: data?.total_price,
              cart_discounts: data?.cart_level_discount_applications,
            },
          }),
        );

        // CART DATA LAYER
        window.dataLayer = window.dataLayer || [];
        const productPromises = items.map(function (item) {
          return getProductData(item).then(function (category) {
            return {
              name: item.title,
              id: item.sku || item.variant_id,
              variant: item.variant_title,
              price: (item.price / 100).toFixed(2),
              quantity: item.quantity,
              category: category,
              item_list_name: window.OcItemLists.get({ productId: item.product_id, productHandle: item.handle }),
            };
          });
        });

        Promise.all(productPromises).then(function (productsForDataLayer) {
          dataLayer.push({
            event: 'cart',
            ecommerce: {
              currencyCode: Shopify.currency.active,
              cart: {
                products: productsForDataLayer,
              },
            },
          });
        });

        self.itemCount(data.item_count);
        self.subtotal(data.total_price);
        updateCartDiscounts();
        renderHtml.html('&nbsp');
        self.show(minicart);

        var promises = items.map(function (item) {
          return self.createItem(item);
        });

        Promise.all(promises).then(function () {
          //TO DO REMOVE LOAD
          observeCheckoutButtonValue();
          // updateWishlistContainers();
        });
      });

      $(document)
        .off('click', '.remove-item')
        .on('click', '.remove-item', function () {
          var lineItemId = $(this).data('line');
          self.removeItem(lineItemId);
        });

      $(document)
        .off('click', '.qty-btn')
        .on('click', '.qty-btn', function () {
          var wrapper = $(this).closest('.product_qty_wrapper');
          var lineItemId = wrapper.data('line');
          var input = wrapper.find('.quantity-input');
          var currentQty = parseInt(input.val());
          var errorEl = wrapper.find('.cart-item__error');
          var availableStock = parseInt(input.data('available-stock'));

          if (isNaN(currentQty)) {
            return;
          }

          if ($(this).hasClass('plus')) {
            if (currentQty < availableStock) {
              currentQty += 1;
            } else {
              errorEl.show();
              errorEl
                .find('.cart-item__error-text')
                .text(
                  window.cartStrings.quantityError.replace(
                    '[quantity]',
                    availableStock,
                  ),
                );
            }
          } else if ($(this).hasClass('minus') && currentQty > 1) {
            currentQty -= 1;
            var itemId = $(this).data('id');

            $.getJSON('/cart.js', function (cart) {
              var product = cart.items.find(function (item) {
                return item.id == itemId;
              });

              // REMOVE FROM CART DATALAYER
              if (product) {
                getProductData(product).then(function (category) {
                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({
                    event: 'removeFromCart',
                    ecommerce: {
                      remove: {
                        products: [
                          {
                            name: product.title,
                            id: product.sku,
                            variant: product.variant_title,
                            price: (product.price / 100).toFixed(2),
                            category: category,
                            item_list_name: window.OcItemLists.get({ productId: product.product_id, productHandle: product.handle }),
                            quantity: 1,
                          },
                        ],
                      },
                    },
                  });
                });
              }
            });

            errorEl.hide();
          }
          input.val(currentQty);

          if (currentQty < availableStock && errorEl.is(':visible')) {
            errorEl.hide();
          }
          self.updateItemQuantity(lineItemId, currentQty);
          self.updateItemTotalPrice(
            { id: lineItemId, price: wrapper.data('price') },
            currentQty,
          );
        });
    };

    this.updateItemQuantity = function (lineItemKey, quantity) {
      const previousQuantityEl = document.querySelector(
        `#Quantity-${lineItemKey}`,
      );
      const previousQuantity = parseInt(
        previousQuantityEl?.getAttribute('data-prev') || '0',
      );

      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          id: lineItemKey,
          quantity: quantity,
          sections: ['section_header'],
        },
        dataType: 'json',
        success: function (cart) {
          if (cart && cart?.sections && cart?.sections?.section_header) {
            const text = cart.sections.section_header;
            if (typeof text === 'string' && text.trim()) {
              const parser = new DOMParser();
              const html = parser.parseFromString(text, 'text/html');
              const trackingInfoUpdated = html.querySelector('#MiniCartTrack');
              const oldTrackingInfo =
                window.document.getElementById('MiniCartTrack');
              if (oldTrackingInfo && trackingInfoUpdated) {
                oldTrackingInfo.innerHTML = trackingInfoUpdated.innerHTML;
              }
            }
          }

          self.itemCount(cart.item_count);
          self.subtotal(cart.total_price);
          updateCartDiscounts();
          self.updateCartItems(cart.items);

          const updatedItem = cart.items.find(
            (item) => item.id === lineItemKey,
          );
          const quantityAdded = quantity - previousQuantity;

          if (previousQuantityEl) {
            previousQuantityEl.setAttribute('data-prev', updatedItem.quantity);
          }

          if (updatedItem && quantityAdded > 0) {
            const variant = updatedItem.variant_title;
            const sku = updatedItem.sku || updatedItem.variant_id;

            window?.OcShopify?.trackAddToCart(updatedItem.url, { quantity: quantityAdded, item: updatedItem });

            // ADD TO CART DATALAYER
            getProductData(updatedItem).then(function (category) {
              dataLayer.push({
                event: 'addToCart',
                ecommerce: {
                  currencyCode: Shopify.currency.active,
                  add: {
                    products: [
                      {
                        name: updatedItem.title,
                        id: sku,
                        variant: variant ? variant : '',
                        price: (updatedItem.price / 100).toFixed(2),
                        category: category,
                        item_list_name: window.OcItemLists.get({ productId: updatedItem.product_id, productHandle: updatedItem.handle }),
                        quantity: quantityAdded,
                      },
                    ],
                  },
                },
              });
            });
          }
        },
        error: function (e) {
          if (
            e &&
            e.responseJSON.description &&
            e.responseJSON.description.includes('availability')
          ) {
            const errorEl = document.getElementById(
              `Line-item-error-${lineItemKey}`,
            );
            const availableStock = document
              .getElementById(`Quantity-${lineItemKey}`)
              ?.getAttribute('data-available-stock');

            if (errorEl) {
              errorEl.querySelector('.cart-item__error-text').innerHTML =
                window.cartStrings.quantityError.replace(
                  '[quantity]',
                  availableStock,
                );
            }
          }
        },
      });
    };

    this.setRenderH = function () {
      var WH = $(window).outerHeight(true);
      var MTW = $('.minicart_top_wrp').height();
      var MCF = $('.cart-footer').height();
      var renderH = WH - (MTW + MCF);
      renderHtml.height(renderH);
    };

    this.createItem = function (item) {
      return self.getProduct(item.handle, item);
    };

    this.getProduct = function (handle, item) {
      return new Promise(function (resolve) {
        $.getJSON('/products/' + handle + '.js', function (product) {
          var html =
            '<div class="product-mini-cart" id="product-mini-cart-' +
            item.id +
            '"><a href="' +
            item.url +
            '" id="cart-notification-product-' +
            item.id +
            '" class="cart-item">';
          var title = item.product_title.split('-');
          const variant = product.variants.find(
            (v) => v.id === item.variant_id,
          );

          if (item.image) {
            html +=
              '<div class="cart-notification-product__image  cart_item_media">\n' +
              '                        <img\n' +
              '                            src="' +
              item.featured_image.url +
              '"\n' +
              '                            alt="' +
              item.featured_image.alt +
              '"\n' +
              '                            width="' +
              item.featured_image.width +
              '"\n' +
              '                            height="' +
              item.featured_image.height +
              '"\n' +
              '                            class="image_minicart"\n' +
              '                            loading="lazy"\n' +
              '                        >\n' +
              '                    </div>';
          }

          html += '</a>';

          const totalPrice = item.final_line_price;

          html +=
            '<div class="cart_item_info"> ' +
            '<p class="product_title">' +
            title[0] +
            '</p>' +
            '<span class="total-price-product">' +
            self.formatMoney(totalPrice, money_format) +
            '</span>' +
            (title[1] ? '<p class="product_type">' + title[1] + '</p>' : '') +
            '<div class="info_elm"> <div class="container-price"><div class="text-price">';
          if (product.compare_at_price > product.price) {
            html +=
              '<span class="special_price">' +
              self.formatMoney(item.final_price, money_format) +
              '</span></div>';
          } else {
            html +=
              '<span class="regular_price">' +
              self.formatMoney(item.final_price, money_format) +
              '</span></div>';
          }

          html += '</div>';

          html += `<div class="attributes-wishlist-group">`;

          if (item.options_with_values && item.options_with_values.length > 0) {
            html += '<div class="container-attributes">';
            item.options_with_values.forEach(function (i) {
              if (item.gift_card) {
                return;
              }
              html +=
                '<p class="product_attribute">' +
                i.name +
                ': ' +
                i.value +
                '</p>';
            });
            if (item.properties) {
              for (const key in item.properties) {
                const value = item.properties[key];
                
                if (!value || key.startsWith('_')) {
                  continue;
                }

                if (key === 'Color') {
                  html += `<p class="product_attribute">${textColorMetafield}: ${value}</p>`;
                } else {
                  html +=  `<p class="product_attribute product_attribute--property product_attribute--${key.toLowerCase().replaceAll(' ', '-')}">
                    <span class="product_attribute--key">${key}:</span>
                    <span class="product_attribute--value">${value}</span>
                  </p>`;
                }
              }
            }

            html += '</div>';
          }

          /*
          html += `<div class="container-wishlist">
            <span class="smartwishlist cartwishlist text-[16px] leading-[24px] smartwishlist_button"
            data-product="${item.product_id}"
            data-variant="${item.variant_id}">
            </span></div>`;
          */

          html += `</div>`;

          html += `<div class="container-quantity-remove">
                <div class="product_qty_wrapper" data-line="${item.id}">
                   <div class="container-quantity-input">
                    <button class="qty-btn minus" data-id="${item.id}" aria-label="Decrease quantity for ${item.title}">-</button>
                    <input type="text" class="quantity-input" value="${item.quantity}" readonly id="Quantity-${item.id}" data-available-stock="${variant.inventory_quantity}" data-prev="${item.quantity}" />
                    <button class="qty-btn plus" data-id="${item.id}" aria-label="Increase quantity for ${item.title}">+</button>

                     <button class="remove-item" data-line="${item.id}" aria-label="Remove item ${item.title}">${removeText}</button>
                   </div> 
                    <div class="cart-item__error text-[12px] leading-[16px] mt-[5px]" id="Line-item-error-${item.id}">
                        <span class="cart-item__error-text text-[12px] leading-[16px] text-[#EB001B]"></span>
                    </div>
                </div>
              `;

          html += '</div>';

          html += '</div></div></div>';

          renderHtml.append(html);
          resolve();
        });
      });
    };

    this.removeItem = function (lineItemId) {
      $.getJSON('/cart.js', function (cart) {
        var removedProduct = cart.items.find(function (item) {
          return item.id === lineItemId;
        });
        getProductData(removedProduct).then(function (category) {
          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: {
              updates: {
                [lineItemId]: 0,
              },
            },
            dataType: 'json',
            success: function (cart) {
              self.itemCount(cart.item_count);
              self.subtotal(cart.total_price);
              self.updateCartItems(cart.items);
              updateCartDiscounts();

              // REMOVE FROM CART DATALAYER
              if (removedProduct) {
                dataLayer.push({
                  event: 'removeFromCart',
                  ecommerce: {
                    currencyCode: Shopify.currency.active,
                    remove: {
                      products: [
                        {
                          name: removedProduct.title,
                          id: removedProduct.sku,
                          variant: removedProduct.variant_title,
                          price: (removedProduct.price / 100).toFixed(2),
                          category: category,
                          item_list_name: window.OcItemLists.get({ productId: removedProduct.product_id, productHandle: removedProduct.handle }),
                          quantity: removedProduct.quantity,
                        },
                      ],
                    },
                  },
                });
              }
              $('#product-mini-cart-' + lineItemId).remove();
            },
            error: function (err) {},
          });
        });
      });
    };

    this.updateCartItems = function (items) {
      items.forEach(function (item) {
        if (item.quantity <= 0 || !item.id || !item.variant_id) {
          return;
        }

        var existingItem = $('#cart-notification-product-' + item.id);

        if (existingItem.length > 0) {
          existingItem.find('.quantity-input').val(item.quantity);
          self.updateItemTotalPrice(item, item.quantity);
        } else {
          self.createItem(item);
        }
      });
    };

    this.updateItemTotalPrice = function (item, currentQty) {
      const price = parseFloat(item.price);
      const quantity = parseInt(currentQty);

      if (isNaN(price) || isNaN(quantity)) {
        return;
      }

      const totalPrice = price * quantity;

      const productTotalPriceElement = $('#product-mini-cart-' + item.id).find(
        '.total-price-product',
      );

      if (productTotalPriceElement.length > 0) {
        productTotalPriceElement.text(
          self.formatMoney(totalPrice, money_format),
        );
      }
    };

    this.show = function (obj) {
      obj.addClass('active').show();
      self.setRenderH();
      $('body').addClass('overflow-hidden');
      $(window).resize(function () {
        self.setRenderH();
      });
    };

    this.close = function (obj) {
      obj.removeClass('active').hide();
      $('body').removeClass('overflow-hidden');
    };

    this.itemCount = function (count) {
      itemCountTotal.html(count);
      $('.cart-count-bubble span').html(count);
    };

    this.subtotal = function (value) {
      $('.subtotale_value').html(self.formatMoney(value, money_format));
      window.updateCartFreeShippingMessages?.(value);
    };

    this.formatMoney = function (cents, format) {
      var value = '';
      var patt = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || '$ {{amount}}';
      switch (formatString.match(patt)[1]) {
        case 'amount':
          value = (cents / 100.0)
            .toFixed(2)
            .toString()
            .replace(/(\d+)(\d{3}[\.,]?)/, '$1 $2');
          break;
        case 'amount_no_decimals':
          value = Math.round(cents / 100.0)
            .toString()
            .replace(/(\d+)(\d{3}[\.,]?)/, '$1 $2');
          break;
        case 'amount_with_comma_separator':
          value = (cents / 100.0)
            .toFixed(2)
            .toString()
            .replace(/\./, ',')
            .replace(/(\d+)(\d{3}[\.,]?)/, '$1.$2');
          break;
      }
      return formatString.replace(patt, value);
    };

    close.on('click', function () {
      self.close(minicart);
    });

    function updateCartDiscounts() {
      $.getJSON('/cart.js', function (cart) {
        var discountContainer = $('.discounts-container');
        var html = '';

        // discount cart
        if (
          cart.cart_level_discount_applications &&
          cart.cart_level_discount_applications.length > 0
        ) {
          cart.cart_level_discount_applications.forEach(function (discount) {
            html += `<div class="container-discount">
          <div class="discount-label text-black">
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount color-foreground-{{ settings.accent_icons }}" viewBox="0 0 12 12">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path>
            </svg>
            <strong>${discount.title}</strong>
          </div>
          <p class="discount-amount text-black">(-${self.formatMoney(discount.total_allocated_amount, money_format)})</p>
        </div>`;
          });
        }

        // discount product
        let totalDiscounts = {};

        cart.items.forEach(function (item) {
          if (
            item.line_level_discount_allocations &&
            item.line_level_discount_allocations.length > 0
          ) {
            item.line_level_discount_allocations.forEach(function (discount) {
              const discountTitle = discount.discount_application.title;
              const discountAmount = parseFloat(discount.amount);

              if (totalDiscounts[discountTitle]) {
                totalDiscounts[discountTitle] += discountAmount;
              } else {
                totalDiscounts[discountTitle] = discountAmount;
              }
            });
          }
        });

        for (const title in totalDiscounts) {
          if (totalDiscounts.hasOwnProperty(title)) {
            const amount = totalDiscounts[title];
            console.log(amount);
            html += `<div class="container-discount">
        <div class="discount-label text-black">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount color-foreground-{{ settings.accent_icons }}" viewBox="0 0 12 12">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path>
          </svg>
          <strong>${title}</strong>
        </div>
        <p class="discount-amount text-black">(-${self.formatMoney(amount, money_format)})</p>
      </div>`;
          }
        }

        if (html) {
          discountContainer.html(html).show();
        } else {
          discountContainer.empty().hide();
        }
      });
    }
  }

  let cartViewPushed = false;

  $('#cart-icon-bubble').on('click', function () {
    $('#cart-notification').minicart();

    if (!cartViewPushed && typeof pushDataLayerCartView === 'function') {
      pushDataLayerCartView();
      cartViewPushed = true;
    }

    return false;
  });

  $.fn.extend({
    minicart: function () {
      new minicart($(this)).init();
    },
  });

  function observeCheckoutButtonValue() {
    const checkoutButton = document.getElementById('checkout');
    const checkoutLink = document.getElementById('cart-notification-button');

    if (!checkoutButton || !checkoutLink) return;

    const updateLink = () => {
      const value = checkoutButton.value;

      if (value && value !== '') {
        checkoutLink.textContent = value;
      }
    };

    const observer = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'value'
        ) {
          updateLink();
        }
      }
    });

    observer.observe(checkoutButton, { attributes: true });

    updateLink();
  }

  function getProductData(item) {
    return $.getJSON(`/products/${item.handle}.json`).then(
      function (productData) {
        const tags = productData.product.tags
          .split(',')
          .map((tag) => tag.trim());

        let category = '';
        const categories = {
          Men: {
            Boots: 'Men/Boots',
            Oxford: 'Men/Oxford',
            Derby: 'Men/Derby',
            Loafers: 'Men/Loafers',
            Sneakers: 'Men/Sneakers',
            Sandals: 'Men/Sandals',
            Accessories: 'Men/Accessories',
          },
          Women: {
            Boots: 'Women/Boots',
            Oxford: 'Women/Oxford',
            Derby: 'Women/Derby',
            Loafers: 'Women/Loafers',
            Sneakers: 'Women/Sneakers',
            Sandals: 'Women/Sandals',
            Accessories: 'Women/Accessories',
          },
        };

        let men = false;
        let women = false;
        let boots = false;
        let oxford = false;
        let derby = false;
        let loafers = false;
        let sneakers = false;
        let sandals = false;
        let accessories = false;

        tags.forEach((tag) => {
          if (tag === 'Men') men = true;
          if (tag === 'Women') women = true;
          if (tag === 'Boots') boots = true;
          if (tag === 'Oxford') oxford = true;
          if (tag === 'Derby') derby = true;
          if (tag === 'Loafers') loafers = true;
          if (tag === 'Sneakers') sneakers = true;
          if (tag === 'Sandals') sandals = true;
          if (tag === 'Accessories') accessories = true;
        });

        // Determina la categoria in base ai tag
        if (men && boots) category = categories['Men']['Boots'];
        if (men && oxford) category = categories['Men']['Oxford'];
        if (men && derby) category = categories['Men']['Derby'];
        if (men && loafers) category = categories['Men']['Loafers'];
        if (men && sneakers) category = categories['Men']['Sneakers'];
        if (men && sandals) category = categories['Men']['Sandals'];
        if (men && accessories) category = categories['Men']['Accessories'];
        if (women && boots) category = categories['Women']['Boots'];
        if (women && oxford) category = categories['Women']['Oxford'];
        if (women && derby) category = categories['Women']['Derby'];
        if (women && loafers) category = categories['Women']['Loafers'];
        if (women && sneakers) category = categories['Women']['Sneakers'];
        if (women && sandals) category = categories['Women']['Sandals'];
        if (women && accessories) category = categories['Women']['Accessories'];

        return category;
      },
    );
  }

  /*
  function updateWishlistContainers() {
    var $buttons = $('#cart-notification-product .smartwishlist_button');

    if ($buttons.length > 0 && typeof window.SmartWishlistMain === 'function') {
      window.SmartWishlistMain();
    }
  }
  */
})(jQuery);
